import { render, staticRenderFns } from "./SupplierCSR.vue?vue&type=template&id=57e7ffc7&scoped=true"
import script from "./SupplierCSR.vue?vue&type=script&lang=js"
export * from "./SupplierCSR.vue?vue&type=script&lang=js"
import style0 from "./SupplierCSR.vue?vue&type=style&index=0&id=57e7ffc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e7ffc7",
  null
  
)

export default component.exports